import i18next from "i18next";
import { initReactI18next } from 'react-i18next';
import { eng } from './en';
import { esp } from './es';
import { zh } from './zh';

i18next
.use(initReactI18next)
.init({
    interpolation: {
        // React configura este valor por defecto a true
        // Por cuestiones de seguridad frente a ataques XSS es recomedable dejarlo en true
        // Si vamos a utilizar el sistema de internaciolización para algo mas que texto
        escapeValue: false,
    },
    lng: 'es', // Idioma por defecto 
    resources: {
        // Aqui ponemos cada uno de los idiomas que vayamos a utilizar
        en: {
            translation: eng,
        },
        es: { 
            translation: esp,
        },
        zh: {
            translation: zh,
        }
    },
})

export default i18next;